import axios from "axios";
import { BASIC } from "../mutation-types"
import { useCookies } from "vue3-cookies"
const { cookies } = useCookies()
const state = {
    user: {
        userId: 0,
        userName: '',
        userEmail: '',
        userPhoneNumber: '',
        nickName: '',
        companyId: null,
        companyName: null,
    },
    saveEmail: '',
    codes: {

    },
    auth: {
        accessToken: '',
        refreshToken: '',
        expired: '',
        userRoles: []
    },
    activeMenu: '1',
    appName: '임시앱네임',
}

const getters = {
    userEmail: (state) => {
        return state.saveEmail
    },
    userInfo: (state) => {
        return state.user;
    },
    userRoles: (state) => {
        return state.auth.userRoles;
    },
    accessToken: (state) => {
        return state.auth.accessToken;
    },
    refreshToken: (state) => {
        return state.auth.refreshToken;
    },
    expired: (state) => {
        return state.auth.expired;
    },
    activeMenu: (state) => {
        return state.activeMenu;
    },
    auth: (state) => {
        return state.auth;
    },
    appName: (state) => {
        return state.appName;
    },
    codes: (state) => {
        return state.codes;
    }
}

const actions = {
    setEmail ({commit}, value){
        commit(BASIC.SET_EMAIL, value)
    },
    setAuth ({ commit }, value){
        commit(BASIC.SET_AUTH, value)
    },
    setMenuIdx ({ commit }, value){
        commit(BASIC.SET_MENU_IDX, value)
    },
    setUser ({ commit }, value){
        commit(BASIC.SET_USER, value)
    },
    initToken ({ commit }, value){
        commit(BASIC.INIT_TOKEN, value)
    },
    initRToken ({ commit }, value){
        commit(BASIC.INIT_RTOKEN, value)
    },
    initUser ({ commit }){
        commit(BASIC.SET_USER, {
            id: 0,
            name: '',
            email: '',
            phoneNumber: '',
            zem: 0
        })
    },
    refreshToken ({ commit }, rt, userId){
        return new Promise((resolve, reject) => {

            axios.post('/user/sign-in/refresh', {
                refreshToken: rt,
                userId: userId,
                remember: !!JSON.parse(cookies.get("remember")),
            }).then(res => {
                console.log('Success Token Refresh')
                commit(BASIC.SET_AUTH, res.data.response)
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    setAppName ({ commit }, value){
        commit(BASIC.SET_APP_NAME, value)
    },
    setCodes({ commit }, value){
        commit(BASIC.SET_CODES, value)
    }
}

const mutations = {
    [BASIC.SET_EMAIL] (state, value){
        state.saveEmail = value
    },
    [BASIC.SET_USER] (state, value){
        state.user = value;
    },
    [BASIC.INIT_USER] (state, value){
        state.user = value;
    },
    [BASIC.SET_AUTH] (state, value){
        state.auth = value;
    },
    [BASIC.SET_MENU_IDX] (state, value){
        state.activeMenu = value;
    },
    [BASIC.INIT_TOKEN] (state, value){
        state.auth.accessToken = value;
    },
    [BASIC.INIT_RTOKEN] (state, value){
        state.auth.refreshToken = value;
    },
    [BASIC.SET_APP_NAME] (state, value){
        state.appName = value;
    },
    [BASIC.SET_CODES] (state, value){
        state.codes = value;
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
